// Depends on: AquaTechTheme-head.js
"use strict";

AquaTechTheme.$ = jQuery;

AquaTechTheme.loadModules();

AquaTechTheme.initDocMediaLists = function($lists) {
  var self = this;
  var $ = self.$;

  $lists.each(function() {
    var $list = $(this);
    $list.wrap('<div class="doc-media-list-wrap"></div>');
    var $btn = $('<button class="button doc-media-view disabled">View</button>');
    $list.after($btn);
    $btn.on('click', function(e) {
      e.preventDefault();
      //self.onDocMediaView($list); // Handled by KnowledgeCenter.js
    });

    $list.on('change', function(e) {
      if (this.value) {
        $btn.removeClass('disabled');
      } else {
        $btn.addClass('disabled');
      }
    });

    $list.select2();
  });
};

AquaTechTheme.productComplimentaryLoadFix = function() {
  var testEvent = new CustomEvent("product-blocks-ready", { "detail": "Product Blocks Ready" });
  document.dispatchEvent(testEvent);  
};

AquaTechTheme.onDocMediaView = function($list) {
  var self = this;

  window.open($list.val(), '_blank').focus();
}

AquaTechTheme.initElements = function() {
  var self = this;
  var $ = self.$;
  
  self.$window = $(window);
  self.$body   = $('body');
  
  self.urlBase = window.location.origin + '/';
  self.route = window.location.pathname;
  
  self.pageIs = {
    'page': false,
    'collection': false,
    'product': false,
    'article': false,
    'home': false,
  };
  var bodyClass = self.$body.attr('class');
  if (!bodyClass) { return; }
  var bodyClasses = bodyClass.split(' ');
  for (var ci = 0; ci < bodyClasses.length; ci++) {
    var bclass = bodyClasses[ci];
    if (bclass == 'template-index') { self.pageIs.home = true; break; }
    if (bclass == 'template-article') { self.pageIs.article = true; break; }
    if (bclass.startsWith('template-page')) { self.pageIs.page = true; break; }
    if (bclass.startsWith('template-collection')) { self.pageIs.collection = true; break; }
    if (bclass.startsWith('template-product')) { self.pageIs.product = true; break; }
  }
};

AquaTechTheme.initUIElements = function() {
  var self = this;
  
  var accordions = Array.from(document.querySelectorAll('.accordion-container'));
  new Accordion(accordions);

  var $docMediaLists = $('.doc-media-list');
  if ($docMediaLists.length) {
    self.initDocMediaLists($docMediaLists);
  }
}

AquaTechTheme.test = function() {
  var self = this;

  self.addHeightFitGroup('.hfit');
  self.updateHeightFitGroups();
};

AquaTechTheme.initFoot = function() {
  var self = this;
  var $ = self.$;

  AquaTechTheme.initElements();
  AquaTechTheme.initUIElements();

  AquaTechTheme.dlog('AquaTechTheme.initFoot() done.');
};
(function() { AquaTechTheme.initFoot(); })();

AquaTechTheme.initFootOnDocReady = function() {
  var self = this;
  var $ = self.$;

  AquaTechTheme.dlog('AquaTechTheme.initFootOnDocReady() done.');
};
AquaTechTheme.$(function() { AquaTechTheme.initFootOnDocReady(); });

AquaTechTheme.initFootOnWindowLoad = function() {
  var self = this;
  var $ = self.$;


  if (self.pageIs.product) {
    AquaTechTheme.productComplimentaryLoadFix();
  }
};
AquaTechTheme.$(window).on("load", function() { AquaTechTheme.initFootOnWindowLoad(); });

AquaTechTheme.onWindowResize = function() {
  var self = this;
  var $ = self.$;

  self.updateHeightFitGroups();
};
AquaTechTheme.$(window).resize(function() { AquaTechTheme.onWindowResize(); });
